import {
  BaseElementWidget,
  CustomWidget,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import BillingBillListPage from '../../components/BillingBillListPage.vue';

/**
 * 经销商开票列表页 - 完全自定义 Widget
 * 替换 Oinone 默认 Table 视图
 */
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['BillingBillListPage']
  })
)
export class BillingBillListWidget extends CustomWidget {
  public initialize(props: any) {
    super.initialize(props);
    this.setComponent(BillingBillListPage);
    return this;
  }
}
